export default __webpack_public_path__ + "static/media/MyPersonalImage.3e794c05.webp";